// ═══════════════════════════════════════════════════════════════════════════════
// Map AI weather emoji + local hour to heading SVG icon or raw emoji
// ═══════════════════════════════════════════════════════════════════════════════

export type WeatherGreetingHeadingSvgVariant =
  | 'earlyMorning'
  | 'lateMorning'
  | 'afternoon'
  | 'evening'
  | 'lateNight';

export type WeatherGreetingHeadingDisplay =
  | { kind: 'svg'; variant: WeatherGreetingHeadingSvgVariant }
  | { kind: 'emoji'; emoji: string };

export const resolveWeatherGreetingHeadingDisplay = (
  emoji: string,
  hour: number,
): WeatherGreetingHeadingDisplay => {
  const isMorningMoon = emoji === '🌙' && hour === 5;
  const isMorningSun = emoji === '☀️' && hour >= 6 && hour <= 11;

  if (isMorningMoon || isMorningSun) {
    if (hour >= 5 && hour <= 8) {
      return { kind: 'svg', variant: 'earlyMorning' };
    }
    if (hour >= 9 && hour <= 11) {
      return { kind: 'svg', variant: 'lateMorning' };
    }
  }

  if (emoji === '🌤️' && hour >= 12 && hour <= 17) {
    return { kind: 'svg', variant: 'afternoon' };
  }

  if (emoji === '🌙') {
    if (hour >= 18 && hour <= 23) {
      return { kind: 'svg', variant: 'evening' };
    }
    if (hour >= 0 && hour <= 4) {
      return { kind: 'svg', variant: 'lateNight' };
    }
  }

  return { kind: 'emoji', emoji };
};
